import { MenuEffects } from './menu.effects'

export * from './menu.effects'

export const effects: any[] = [MenuEffects]



// WEBPACK FOOTER //
// ./src/app/shared/navbar/menu/store/effects/index.ts